<template>
    <v-container max-width="100%" style="margin-top: 2%">
      <template>
        <v-row justify="center">
          <v-dialog v-model="autorizacaoDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">Mensagem do Sistema</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemAutorizacaoDialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red accent-4" class="white--text" @click="logout"
                  >Logout</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <v-dialog v-model="dialogPlotagem" fullscreen>
        <v-card>
            <v-toolbar color="primary">
              <v-toolbar-title>
                <div class="headline" style="color: white">Relatório de Plotagem da Viagem</div>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="closePlotagem" dark>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          <v-card-text>
            <RELPlotagem :key="plotagemKey" :viagem="editedItem"/>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-container class="toolbar__container">
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <v-autocomplete
                  v-model="idEmpresaSelected"
                  :items="empresas"
                  item-text="razao_social"
                  item-value="id_empresa"
                  clearable
                  label="Empresa"
                  @change="onEmpresaSelectChanged"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-datetime-picker
                  label="Data Inicial"
                  v-model="dti"
                  :time-picker-props="timeProps"
                  :text-field-props="textFieldProps"
                  :date-picker-props="dtiProps"
                  time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy"
                  clear-text="Fechar"
                >
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                label="Data Final"
                v-model="dtf"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtfProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                clear-text="Fechar"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    fab
                    color="primary darken-1"
                    class="white--text"
                    v-bind="attrs"
                    v-on="on"
                    @click="populaRelatorio"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Pesquisar</span>
              </v-tooltip>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" :md="exibirFiltroVeiculo ? 4 : 6">
                <v-autocomplete
                  v-model="idLinhaSelected"
                  :items="linhasSelect"
                  item-text="nome_linha"
                  item-value="id_linha"
                  clearable
                  label="Linha"
                  @change="linhasSelectChanged"
                  :disabled="isLinhaSelectDisabled"
                  :rules="[(v) => !!v || 'Selecione uma linha']"
                ></v-autocomplete>
              </v-col>
            <v-col cols="12" sm="6" :md="exibirFiltroVeiculo ? 4 : 6">
                <v-autocomplete
                v-model="trechoSelected"
                :items="trechosSelect"
                item-text="descricao_completa"
                clearable
                return-object
                multiple
                label="Trecho"
                @change="trechosSelectChanged"
              ></v-autocomplete>
            </v-col>
            <v-col v-if="exibirFiltroVeiculo" cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="idVeiculoSelected"
                :items="veiculosSelect"
                item-text="numero_ordem"
                item-value="id_veiculo"
                clearable
                multiple
                label="Veículo"
                :disabled="isVeiculoSelectDisabled"
                @change="aplicarFiltroVeiculo"
              ></v-autocomplete>
            </v-col>
            </v-row>
            <v-row v-if="novoTrechoAtivo">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="idCercaInicioNovo"
                  :items="cercasLinha"
                  item-text="nome_cerca"
                  item-value="id_cerca"
                  clearable
                  label="Cerca Inicial"
                  :disabled="!idLinhaSelected"
                  :rules="[(v) => !novoTrechoAtivo || !!v || 'Selecione a cerca inicial']"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="idCercaFimNovo"
                  :items="cercasLinha"
                  item-text="nome_cerca"
                  item-value="id_cerca"
                  clearable
                  label="Cerca Final"
                  :disabled="!idLinhaSelected"
                  :rules="[
                    (v) => !novoTrechoAtivo || !!v || 'Selecione a cerca final',
                    (v) => !novoTrechoAtivo || v !== idCercaInicioNovo || 'Cerca final deve ser diferente da inicial'
                  ]"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

    <merus-data-table
        :headers="headersWithProperties"
        :items="trechosFiltered"
        :sort-by="consultaModoDetalhe ? 'dt_embarque_extenso' : 'saida_cerca'"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loading"
        loading-text="Carregando..."
        :item-class="getColorItem"
        style="border-radius: 10px; margin-bottom: 10px;margin-top: 10px;"
    >
        <template v-slot:toolbar>
            <CadastroToolbar
              title="Embarques por Trecho"
              :token="token"
              :items="trechosFiltered"
              csv-title="embarquestrecho"
              pdf-title="Embarques por Trecho"
              :pdf-headers="consultaModoDetalhe ? headersTabela.filter((h) => h.value !== 'actions') : headersPdf"
              pdf-filename="embarquestrecho"
              :pdf-subtitle="pdfsubtitle"
              hide-search
            />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="orange" @click="abrirPlotagem(item)"
              >mdi-map-marker</v-icon>
        </template>

    </merus-data-table>

    </v-container>
  </template>

  <script>
  import apiController from "@/utils/apiController";
  import MerusDataTable from "./Tables/MerusDataTable.vue";
  import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
  import DateUtils from "../utils/dateutils";
  import RELPlotagem from "./RELPlotagem.vue";

  const NOVO_TRECHO_ITEM = {
    id_trecho: "__NOVO_TRECHO__",
    descricao_completa: "Novo Trecho",
    is_novo_trecho: true,
  };

  export default {
    components: {
    MerusDataTable,
    CadastroToolbar,
    RELPlotagem
},
    data: () => ({
      user: null,
      token: null,
      mensagemAutorizacaoDialog: "",
      autorizacaoDialog: false,
      showConfirmButton: true,
      messageConfirmButton: "Sim",
      messageDismissButton: "Não",
      formValidado: false,
      loading: false,
      headers: [
        { text: "Id Trecho", value: "id_trecho", align: " d-none"},
        { text: "Linha", value: "cod_linha"},
        { text: "Veículo", value: "numero_ordem"},
        { text: "Ponto Inicial", value: "cerca_inicio"},
        { text: "Ponto Final", value: "cerca_fim"},
        { text: "Sentido", value: "descricao_sentido"},
        { text: "Motorista", value: "nome_motorista"},
        { text: "Saída", value: "saida_cerca_extenso"},
        { text: "Chegada", value: "entrada_cerca_extenso"},
        { text: "Tempo", value: "tempo_trecho"},
        { text: "Pagantes", value: "passageiros_pagantes"},
        { text: "Gratuidades", value: "passageiros_gratuidades"},
        { text: "VT", value: "passageiros_vt"},
        { text: "Total", value: "passageiros_totais"},
        { text: "Ações", value: "actions", sortable: false }
      ],
      consultaModoDetalhe: false,
      headersPdf: [
        { text: "Linha", value: "cod_linha"},
        { text: "Veículo", value: "numero_ordem"},
        { text: "Ponto Inicial", value: "cerca_inicio"},
        { text: "Ponto Final", value: "cerca_fim"},
        { text: "Sentido", value: "descricao_sentido"},
        { text: "Motorista", value: "nome_motorista"},
        { text: "Saída", value: "saida_cerca_extenso"},
        { text: "Chegada", value: "entrada_cerca_extenso"},
        { text: "Tempo", value: "tempo_trecho"},
        { text: "Pagantes", value: "passageiros_pagantes"},
        { text: "Gratuidades", value: "passageiros_gratuidades"},
        { text: "VT", value: "passageiros_vt"},
        { text: "Total", value: "passageiros_totais"},
      ],
      textFieldProps: {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || "Selecione uma data !"],
      },
      timeProps: {
        useSeconds: true,
      },
      dti: null,
      dtf: null,
      idEmpresaSelected:  null,
      idLinhaSelected: null,
      trechoSelected: [],
      cercasTrechosSelected: [],
      idVeiculoSelected:  [],
      empresas: [],
      trechosSelect: [],
      cercasLinha: [],
      idCercaInicioNovo: null,
      idCercaFimNovo: null,
      veiculosSelect: [],
      linhasSelect: [],
      veiculos: [],
      posicoes: [],
      trechosLinha: [],
      trechosReporteCompleto: [],
      trechosFiltered: [],
      isVeiculoSelectDisabled: false,
      isLinhaSelectDisabled: false,
      config: null,
      editedItem: {
        id_trecho: null,
        id_veiculo_realizado: null,
        horario_saida_prevista: null,
        horario_chegada_prevista: null,
        id_empresa: null
      },
      defaultItem: {
        id_trecho: null,
        id_veiculo_realizado: null,
        horario_saida_prevista: null,
        horario_chegada_prevista: null,
        id_empresa: null
      },
      plotagemKey: 0,
      dialogPlotagem: false,
    }),
    computed: {
      exibirFiltroVeiculo() {
        return Array.isArray(this.trechosReporteCompleto) && this.trechosReporteCompleto.length > 0;
      },
      novoTrechoAtivo() {
        return Array.isArray(this.trechoSelected) &&
          this.trechoSelected.some((t) => t && t.is_novo_trecho);
      },
      headersTabela() {
        if (!this.consultaModoDetalhe) {
          return this.headers;
        }
        return [
          { text: "Linha", value: "cod_linha" },
          { text: "Veículo", value: "numero_ordem" },
          { text: "Ponto Inicial", value: "cerca_inicio" },
          { text: "Ponto Final", value: "cerca_fim" },
          { text: "Saída", value: "saida_cerca_extenso" },
          { text: "Chegada", value: "entrada_cerca_extenso" },
          { text: "Embarque", value: "dt_embarque_extenso" },
          { text: "Cerca", value: "nome_cerca" },
          { text: "Origem", value: "origem" },
          { text: "Ações", value: "actions", sortable: false },
        ];
      },
      headersWithProperties() {
        return this.headersTabela.map(h => ({ ...h, filtrable: true, sortable: h.sortable !== false }));
      },
      pdfsubtitle() {
        const ids = Array.isArray(this.idVeiculoSelected) ? this.idVeiculoSelected : [];
        const ordemVeiculo = this.veiculosSelect
          .filter((veiculo) => ids.includes(veiculo.id_veiculo))
          .map((v) => v.numero_ordem);

        let subtitle = ""
        if (ordemVeiculo.length > 0) {
          subtitle += `Veículo: ${ordemVeiculo.join(", ")} `
        }
        return subtitle;
      },
      today() {
        return new Date().toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.today
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      }
    },
    watch: {
      idVeiculoSelected() {
        this.aplicarFiltroVeiculo();
      },
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {
      logout() {
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("api");
          var id = window.setTimeout(function () {}, 0);
          while (id--) {
            window.clearTimeout(id);
          }
          this.$router.push({ path: "/" });
      },
      initialize() {
        this.getConfig();
        this.populaEmpresas();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              silent: true,
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              },
              onError: (e) => {
                  console.log("Response : " + e.message);
                  if (e.message == "Request failed with status code 401") {
                    this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                    this.autorizacaoDialog = true;
                  }
              },
          });
        },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          silent: true,
          onSuccess: (response) => {
            this.empresas = response.data;
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          },
        });
      },
      populaTrechos(idlinha) {
        apiController.request(apiController.endpoints.getTrechosporlinha, {
          params: { id: idlinha },
          silent: true,
          onSuccess: (response) => {
            this.trechosLinha = response.data;
            this.trechosSelect = [NOVO_TRECHO_ITEM, ...this.trechosLinha];
            this.trechoSelected = this.trechosLinha;
            this.idCercaInicioNovo = null;
            this.idCercaFimNovo = null;
            this.idVeiculoSelected = [];
            this.trechosReporteCompleto = [];
            this.trechosFiltered = [];
            this.veiculosSelect = [];
            this.populaCercasLinha(idlinha);
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          },
        });
      },
      populaCercasLinha(idlinha) {
        if (!idlinha) {
          this.cercasLinha = [];
          return;
        }
        apiController.request(apiController.endpoints.getCercasporlinha, {
          data: [idlinha],
          silent: true,
          onSuccess: (response) => {
            this.cercasLinha = response.data || [];
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          },
        });
      },
      buildTrechosConsulta() {
        const catalogo = this.trechosLinha.length > 0 ? this.trechosLinha : this.trechosSelect.filter((t) => !t.is_novo_trecho);
        const selecionados = this.trechoSelected.length > 0 ? this.trechoSelected : catalogo;
        return selecionados.filter((t) => t && !t.is_novo_trecho);
      },
      buildTrechoRequestBody(dti, dtf) {
        if (this.novoTrechoAtivo && this.idCercaInicioNovo && this.idCercaFimNovo) {
          return {
            trechoCustom: {
              id_linha: this.idLinhaSelected,
              id_cerca_inicio_trecho: this.idCercaInicioNovo,
              id_cerca_fim_trecho: this.idCercaFimNovo,
            },
            idcercas: [this.idCercaInicioNovo, this.idCercaFimNovo],
            dti,
            dtf,
          };
        }
        const trechos = this.buildTrechosConsulta();
        const catalogo = this.trechosLinha.length > 0 ? this.trechosLinha : this.trechosSelect.filter((t) => !t.is_novo_trecho);
        const lista = trechos.length > 0 ? trechos : catalogo;
        const idsTrecho = lista.flatMap((t) => [t.id_cerca_inicio_trecho, t.id_cerca_fim_trecho]);
        return {
          idtrechos: lista.map((t) => t.id_trecho).filter((id) => id != null),
          idcercas: Array.from(new Set(idsTrecho)),
          dti,
          dtf,
        };
      },
      populaVeiculosSelect() {
        const rows = this.trechosReporteCompleto || [];
        if (rows.length === 0) {
          this.veiculosSelect = [];
          return;
        }
        const map = new Map();
        rows.forEach((t) => {
          if (t.id_veiculo != null) {
            map.set(t.id_veiculo, { id_veiculo: t.id_veiculo, numero_ordem: t.numero_ordem });
          }
        });
        this.veiculosSelect = Array.from(map.values()).sort((a, b) =>
          String(a.numero_ordem).localeCompare(String(b.numero_ordem), undefined, { numeric: true })
        );
      },
      aplicarFiltroVeiculo() {
        const rows = this.trechosReporteCompleto || [];
        const ids = Array.isArray(this.idVeiculoSelected) ? this.idVeiculoSelected.filter((id) => id != null) : [];
        if (ids.length === 0) {
          this.trechosFiltered = rows.slice();
        } else {
          this.trechosFiltered = rows.filter((r) => r.id_veiculo != null && ids.includes(r.id_veiculo));
        }
      },
      populaLinhasSelect(id_empresa) {
        apiController.request(apiController.endpoints.getLinhasporempresa, {
          params: { id: id_empresa },
          silent: true,
          onSuccess: (response) => {
            this.linhasSelect = response.data;
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          },
        });
      },
      populaEmbarquesTrecho() {
        this.loading = true;
        let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

        const body = this.buildTrechoRequestBody(dataInicial, dataFinal);

          this.consultaModoDetalhe = false;
        apiController.request(apiController.endpoints.getEmbarquestrecho, {
          data: body,
          silent: true,
          onSuccess: (response) => {
            this.trechosReporteCompleto = response.data || [];
            this.populaVeiculosSelect();
            this.aplicarFiltroVeiculo();
            this.loading = false;
          },
          onError: (e) => {
            this.loading = false;
            this.trechosReporteCompleto = [];
            this.trechosFiltered = [];
            this.veiculosSelect = [];
            this.idVeiculoSelected = [];
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          },
        });
      },
      populaRelatorio() {
        this.$refs.form.validate();
        if (this.formValidado) {
          this.trechosReporteCompleto = [];
          this.trechosFiltered = [];
          this.populaEmbarquesTrecho();
          this.$nextTick(() => { this.$refs.form.resetValidation(); });
        }
      },
      linhasSelectChanged() {
        this.idCercaInicioNovo = null;
        this.idCercaFimNovo = null;
        this.consultaModoDetalhe = false;
        this.cercasLinha = [];
        this.populaTrechos(this.idLinhaSelected);
      },
      onEmpresaSelectChanged() {
        this.populaLinhasSelect(this.idEmpresaSelected);
      },
      trechosSelectChanged() {
        if (this.novoTrechoAtivo) {
          this.trechoSelected = this.trechoSelected.filter((t) => t.is_novo_trecho);
          return;
        }
        this.idCercaInicioNovo = null;
        this.idCercaFimNovo = null;
        this.consultaModoDetalhe = false;
      },
      getColorItem(item) {
        const tempo = Number(item.tempo_trecho);
        if (!Number.isFinite(tempo)) {
          return "trecho__incompleto";
        }

        const min = Number(item.tempo_minimo);
        if (Number.isFinite(min) && tempo < min) {
          return "tempo__abaixo__minimo";
        }

        const max = Number(item.tempo_maximo);
        if (Number.isFinite(max) && tempo > max) {
          return "tempo__acima__maximo";
        }

        return "tempo__ok";
      },
      abrirPlotagem(item) {
        this.editedItem.id_trecho = item.id_trecho;
        this.editedItem.id_veiculo_realizado = item.id_veiculo;
        this.editedItem.horario_saida_prevista = item.saida_cerca;
        this.editedItem.horario_chegada_prevista = item.entrada_cerca;
        this.editedItem.id_empresa = item.id_empresa;
        this.plotagemKey = this.plotagemKey === 0 ? 1 : 0;
        this.dialogPlotagem = true;
      },
      closePlotagem() {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.dialogPlotagem = false;
      }
    },
  };
  </script>

<style>
  ::v-deep tr.tempo__abaixo__minimo td {
    color: darkorange !important;
    font-weight: bold;
  }

  ::v-deep tr.tempo__acima__maximo td {
    color: red !important;
    font-weight: bold;
  }

  ::v-deep tr.tempo__ok td {
    color: green !important;
    font-weight: bold;
  }

  ::v-deep tr.trecho__incompleto td {
    color: #4a4a4a !important;
  }
</style>
